import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// import { ConsultationHistoryComponent } from './name.component';
import { ConsultationHistoryComponent } from './consultation-history.component';

const routes: Routes = [
    { path: '', component: ConsultationHistoryComponent }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ConsultationHistoryRoutingModule { }



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-history/consultation-history-routing.module.ts